module.exports = __webpack_public_path__ + "static/architecture-bfe6f167dbd09a97b2c56eccac59839f.svg";